import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const COPY = {
  not_found: { icon: "📡", title: "This Live Beam isn't available", body: "The link may be wrong, or the room was removed. Browse what's live right now." },
  network: { icon: "📶", title: "We couldn't load this room", body: "Check your connection, then try again. If it keeps happening, close the app and reopen the link." },
};

export const BeamLoadError = ({ kind = "network", onRetry }) => {
  const c = COPY[kind] || COPY.network;
  return (
    <div className="min-h-screen bg-[#08060f] text-white flex items-center justify-center px-6" data-testid="live-room-load-error" data-kind={kind}>
      <div className="max-w-sm text-center space-y-3">
        <p className="text-4xl" aria-hidden>{c.icon}</p>
        <h1 className="text-xl font-black">{c.title}</h1>
        <p className="text-sm text-pink-100/70">{c.body}</p>
        <div className="flex justify-center gap-2 pt-2">
          {kind === "network" && <Button onClick={onRetry} className="bg-gradient-to-r from-rose-500 to-pink-500 font-bold" data-testid="live-room-load-retry">Try again</Button>}
          <Link to="/beams"><Button variant="outline" className="border-pink-500/40 text-pink-100" data-testid="live-room-load-back">See live rooms</Button></Link>
        </div>
      </div>
    </div>
  );
};
